import {useGetExpenseManagementConfiguration} from 'api/expenses';
import {
    useGetCardTransactionDetailsPublic,
    useUploadCardTransactionDetailFilePublic,
} from 'api/transactions';
import {fileUploadStore} from 'components/ui/FileUpload/fileUploadStore';
import {expenseFileUploadValidationSchema} from 'form/validation/expenses';
import {useParams} from 'react-router';
import {HashParamType} from 'types/common';
import {v4 as uuidV4} from 'uuid';
import {ValidationError} from 'yup';

const useExpensesPublicPage = () => {
    const {hash} = useParams<HashParamType>();
    const {mutate: uploadFile} = useUploadCardTransactionDetailFilePublic();
    const addFile = fileUploadStore(state => state.addFile);
    const updateFileStatus = fileUploadStore(state => state.updateFileStatus);
    const {data, isLoading} = useGetCardTransactionDetailsPublic(hash);

    const handleFileUpload = (file: File) => {
        if (!data) return;

        const uuid = uuidV4();
        try {
            expenseFileUploadValidationSchema.validateSync({file});
            addFile({file, uuid});
            uploadFile(
                {
                    hash,
                    file,
                },
                {
                    onSuccess: document =>
                        updateFileStatus({uuid, status: 'uploaded', document}),
                    onError: err => {
                        updateFileStatus({
                            uuid,
                            status: 'error',
                            errorMsg:
                                (err as any)?.['hydra:description'] ||
                                'Something went wrong',
                        });
                    },
                },
            );
        } catch (err) {
            const errorMsg =
                err instanceof ValidationError
                    ? err.message
                    : 'Something went wrong.';

            addFile({
                uuid,
                file,
                status: 'error',
                errorMsg,
            });
        }
    };

    return {
        handleFileUpload,
        data,
        isLoading,
        addFile,
    };
};

export default useExpensesPublicPage;
